module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('table', {
    staticClass: "table table-striped table-hover",
    staticStyle: {
      "margin-bottom": "0px"
    }
  }, [_c('thead', [_c('tr', _vm._l((_vm.headers), function(header, index) {
    return _c('th', {
      style: (header.style),
      on: {
        "click": function($event) {
          _vm.sort(index)
        }
      }
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v("\n                        " + _vm._s(header.title) + "\n                        "), _c('div', {
      staticClass: "pull-right"
    }, [(header.sortBy != '') ? _c('span', {
      staticClass: "fa",
      class: {
        'fa-sort-amount-asc': header.sortBy == 'asc', 'fa-sort-amount-desc': header.sortBy == 'desc'
      }
    }) : _vm._e()])])])
  }))]), _vm._v(" "), _c('tbody', _vm._l((_vm.tempRows), function(row, rowIndex) {
    return _c('tr', {
      class: {
        lastRow: _vm.isLastRow(rowIndex)
      }
    }, _vm._l((row), function(cell, columnName, index) {
      return _c('td', {
        style: (cell < 1 ? 'color: #999' : '')
      }, [(_vm.headers[index].isHtml) ? _c('div', {
        domProps: {
          "innerHTML": _vm._s(_vm.cellFormat(_vm.headers[index], cell))
        }
      }) : _c('div', [_vm._v("\n                        " + _vm._s(_vm.cellFormat(_vm.headers[index], cell)) + "\n                    ")]), _vm._v(" "), (_vm.hasColumnAction(columnName)) ? _c('div', [_c('div', {
        staticClass: "btn-group"
      }, _vm._l((_vm.getColumnActions(columnName)), function(action, actionIndex) {
        return _c('button', {
          staticClass: "btn btn-sm primary",
          on: {
            "click": function($event) {
              _vm.callColumnAction(columnName, row, actionIndex)
            }
          }
        }, [_vm._v(_vm._s(action.title))])
      }))]) : _vm._e()])
    }))
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-028240e8!./~/vue-loader/lib/selector.js?type=template&index=0!./public/src/components/table.v2.vue
// module id = 333
// module chunks = 0